import { Component } from '@angular/core';
import { ContextService, MenuOptionUrl } from 'projects/cross-study-portal-lib/src/public-api';

@Component({
  selector: 'mcp-help-menu',
  templateUrl: './help-menu.component.html',
})
export class HelpMenuComponent {
  helpMenuUrls: MenuOptionUrl[];
  userLanguage: string;

  constructor(private context: ContextService, private window: Window) {
    this.helpMenuUrls = this.context?.instance.helpMenuUrls;
    this.userLanguage = context?.instance.userLanguage || 'en-US';
  }

  onClick(option: MenuOptionUrl) {
    let url = option.urls[this.userLanguage];
    if (!url) {
      const firstLanguage = Object.keys(option.urls)[0];
      console.warn(`Could not find the url for the user language:${this.userLanguage}, using the first language ${firstLanguage}`);
      url = option.urls[firstLanguage];
    }

    const urlToOpen = new URL(url);
    if (option.menuOption === 'userAgreement') urlToOpen.searchParams.append('returnURL', this.window.location.href);
    this.window.open(urlToOpen.href);
  }
}
